import i18n from '@/utils/i18n';
import React from 'react';
import { formatDate, formatDateWithYear, get12HourFormat } from '@/utils/date';
import { StyleSheet, View } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useTheme } from '@/contexts/theme-context';

export interface ActivityListItemNoteProps {
  content: string;
  createdAt: string;
  employeeName: string | null;
  reminderAt: string | null;
}

export const ActivityListItemNote: React.FC<ActivityListItemNoteProps> = ({
  content,
  createdAt,
  employeeName,
  reminderAt,
}) => {
  const theme = useTheme();

  return (
    <View style={styles.activity}>
      {reminderAt ? (
        <Typography variant="heading-xs">
          {i18n.t('activity_list.reminder', {
            date: formatDateWithYear(reminderAt),
            time: get12HourFormat(
              new Date(reminderAt).getHours(),
              new Date(reminderAt).getMinutes(),
            ),
          })}
        </Typography>
      ) : null}
      <Typography
        testID="activity-list-item-note-content"
        variant="paragraph-md"
      >
        {content}
      </Typography>
      <Typography
        color={theme.sk.color.text.tertiary}
        testID="activity-list-item-note-time"
        variant="paragraph-md"
      >
        {employeeName ? `${employeeName} • ` : null}
        {`${formatDate(createdAt)} ${get12HourFormat(
          new Date(createdAt).getHours(),
          new Date(createdAt).getMinutes(),
        )}`}
      </Typography>
    </View>
  );
};

const styles = StyleSheet.create({
  activity: {
    marginVertical: 8,
  },
});
